import { showCtConfirm } from "@conectate/components/ct-confirm.js";
import { sleep } from "@conectate/components/ct-helpers";
import dayjs from "dayjs";
import { getAuth } from "firebase/auth";

export function getAPIURLv2() {
	// @ts-ignore window.apiURL = "http://localhost:8080/v2";
	// @ts-ignore window.apiURL = "https://api-raw.hirex.app/v2";
	let apiURL = window.apiURL || sessionStorage.apiURL || localStorage.apiURL;
	if (apiURL) return apiURL;
	return process.env.SERVER_URL;
}

function toQueryString(obj: any) {
	var parts = [];
	for (var i in obj) {
		if (obj.hasOwnProperty(i) && obj[i] !== undefined) {
			parts.push(`${encodeURIComponent(i)}=${obj[i] === null ? "" : encodeURIComponent(obj[i])}`);
		}
	}
	return parts.join("&");
}
function cleanObject(obj?: any) {
	if (!obj) return obj;
	for (let key in obj) {
		if (obj[key] === null || obj[key] === undefined) {
			delete obj[key];
		}
	}
	return obj;
}

export namespace xFetch {
	export function createResponse<T, E>(json: T, error: xError<E> | undefined, response: Response): xResponse<T, E> {
		return Object.assign([json, error, response], { response: response, json: json, error: error }) as xResponse<T, E>;
	}

	export interface xResponse<T = any, E = any> extends Array<any> {
		json: T;
		error?: xError<E>;
		response: Response;
		0: T;
		1: xError<E> | undefined;
		2: Response;
	}
	export interface xError<E> {
		number: number;
		status: number;
		error_type: string;
		error_msg: string;
		data?: E;
	}

	export interface Pagination {
		token?: string;
		limit?: string;
		skip?: string;
	}
}

export async function xget<T = any, E = string>(
	url: string,
	params?: Record<string, any>,
	options?: { skipBaseURL?: boolean; noauth?: boolean; headers?: Record<string, string>; retries?: number }
): Promise<xFetch.xResponse<T, E>> {
	let parsedURL: URL;
	let idTokenPromise = getAuth().currentUser?.getIdToken() || Promise.resolve(`no-auth`);
	let retries = options?.retries || 4;
	if (retries < 1) retries = 1;
	let rs: Promise<xFetch.xResponse<T, E>>;
	do {
		rs = new Promise(solve => {
			idTokenPromise
				.then(async idToken => {
					if (options?.skipBaseURL) parsedURL = new URL(url);
					else parsedURL = new URL(getAPIURLv2() + url);
					if (params) parsedURL.search = toQueryString(params);
					let p = await fetch(parsedURL.href, {
						headers: {
							Accept: "application/json, text/javascript, */*; q=0.01",
							Authorization: `bearer ${idToken}`,
							"Content-Type": "application/json",
							"Cache-Control": "no-cache",
							Pragma: "no-cache",
							"accept-language": localStorage.lang || navigator.language.substring(0, 2),
							...(options?.noauth
								? {}
								: {
										"x-lang": localStorage.lang || navigator.language.substring(0, 2),
										"x-timezone": `${Number(dayjs().format("Z").split(":")[0])}`,
										"x-app-version": process.env.VERSION!,
										"x-app-build": process.env.BUILD!,
										"x-ats-id": window.app.localStorage.atsConfig?.id || "",
										"x-ats-name": window.app.localStorage.atsConfig?.title || "",
										"x-path": window.location.pathname + window.location.search,
										...cleanObject(options?.headers)
									})
						},
						method: "GET",
						mode: "cors"
					});

					let jsonResult: any = {};
					try {
						jsonResult = await p.json();
					} catch {}
					if (p.status == 429) {
						showCtConfirm(
							"Parece que has abusado del servicio",
							"Se te ha denegado el servicio temporalmente por un uso inadecuado. Vuelve más tarde. Si vuelves a abusar del uso del servicio podemos inhabilitar tu cuenta de forma temporal o definitiva."
						);
					}

					let r: xFetch.xResponse<T, E> = xFetch.createResponse(jsonResult, undefined, p);
					if (p.status >= 400) {
						r.error = jsonResult;
						r[1] = jsonResult;
						solve(r);
					} else {
						solve(r);
					}
				})
				.catch(function (error) {
					console.error(error);
					let jsonResult: any = {};
					let msg = `${error}`;
					if (msg.includes("Failed to fetch")) msg = "No hay conexión a internet.v1";
					// @ts-ignore
					let r: xFetch.xResponse<T> = [jsonResult, {}, {}];
					r.json = jsonResult;
					r.response = {} as any;
					r.error = {
						status: 0,
						error_msg: msg,
						error_type: msg,
						number: 0
					};
					r[1] = r.error;
					solve(r);
					// debugger;
				});
		});
		let [json, error] = await rs;
		if (error && error.status == 0) {
			retries--;
			await sleep(process.env.NODE_ENV == "development" ? 2_500 : 1_500);
			console.log(retries, "Retrying", url);
			continue;
		}
		break;
	} while (retries > 0);
	return rs;
}

export async function xhttp<T = any, E = null>(
	url: string,
	method: "POST" | "PUT" | "DELETE" | "PATCH" | "SEARCH",
	body?: object | FormData | string,
	options?: { skipBaseURL?: boolean; headers?: Record<string, string>; retries?: number; server_send_events?: (event: string) => void }
): Promise<xFetch.xResponse<T, E>> {
	let parsedURL: URL;
	let idTokenPromise = getAuth().currentUser?.getIdToken() || Promise.resolve(`no-auth`);
	let retries = options?.retries || 4;
	if (retries < 1) retries = 1;
	let rs: Promise<xFetch.xResponse<T, E>>;
	do {
		rs = new Promise((solve, err) => {
			idTokenPromise
				.then(async idToken => {
					if (typeof body == "object" && !(body instanceof FormData)) {
						body = JSON.stringify(body);
					}
					let Content_Type = body instanceof FormData ? "X-Content-Type" : "Content-Type";
					if (options?.skipBaseURL) parsedURL = new URL(url);
					else parsedURL = new URL(getAPIURLv2() + url);
					let response = await fetch(parsedURL.href, {
						headers: {
							Accept: "application/json, text/javascript, */*;",
							Authorization: `bearer ${idToken}`,
							[Content_Type]: "application/json",
							"Cache-Control": "no-cache",
							Pragma: "no-cache",
							"accept-language": localStorage.lang || navigator.language.substring(0, 2),
							"x-lang": localStorage.lang || navigator.language.substring(0, 2),
							"x-timezone": `${Number(dayjs().format("Z").split(":")[0])}`,
							"x-app-version": process.env.VERSION!,
							"x-app-build": process.env.BUILD!,
							"x-ats-id": window.app.localStorage.atsConfig?.id || "",
							"x-ats-name": window.app.localStorage.atsConfig?.title || "",
							"x-path": window.location.pathname + window.location.search,
							...cleanObject(options?.headers)
						},
						body: body,
						method: method,
						mode: "cors"
					});
					// Esto es para cuando el backend envía eventos en tiempo real
					if (options?.server_send_events) {
						const reader = response.body?.getReader();
						const decoder = new TextDecoder(); // Para decodificar los bytes a texto
						if (!reader) return;

						// Bucle para leer el stream
						while (true) {
							const { done, value } = await reader.read();
							if (done) {
								break; // El stream ha finalizado
							}

							const chunk = decoder.decode(value);
							// El backend envía el formato 'data: {...}\n\n'. Lo procesamos.
							const lines = chunk.split("\n\n");

							lines.forEach(line => {
								if (line.startsWith("data: ")) {
									try {
										const json = JSON.parse(line.substring(6)); // Quita 'data: '
										if (json.type != null && json.text == null) {
											options.server_send_events!(JSON.stringify(json));
										} else if (json.text != null) {
											options.server_send_events!(json.text);
										}
									} catch (e) {
										console.error("No se pudo parsear el JSON del chunk:", line);
									}
								}
							});
						}
						// @ts-ignore
						let rsse: xFetch.xResponse<T, any> = [{}, undefined, response];
						rsse.response = response;
						solve(rsse);
					}

					let jsonResult: any = {};
					try {
						jsonResult = await response.json();
					} catch {}
					if (response.status == 429) {
						showCtConfirm(
							"Parece que has abusado del servicio",
							"Se te ha denegado el servicio temporalmente por un uso inadecuado. Vuelve más tarde. Si vuelves a abusar del uso del servicio podemos inhabilitar tu cuenta de forma temporal o definitiva."
						);
					}

					// @ts-ignore
					let r: xFetch.xResponse<T, any> = [jsonResult, undefined, response];
					r.json = jsonResult;
					r.response = response;
					if (response.status >= 400) {
						r.error = jsonResult;
						r[1] = jsonResult;
						solve(r);
					} else {
						solve(r);
					}
				})
				.catch(function (error) {
					console.error(error);
					let jsonResult: any = {};
					let msg = `${error}`;
					if (msg.includes("fetch")) msg = "No hay conexión a internet.";
					// @ts-ignore
					let r: xFetch.xResponse<T> = [jsonResult, {}, {}];
					r.json = jsonResult;
					r.response = {} as any;
					r.error = {
						status: 0,
						error_msg: msg,
						error_type: msg,
						number: 0
					};
					r[1] = r.error;
					solve(r);
					// debugger;
				});
		});
		let [json, error] = await rs;
		if (error && error.status == 0) {
			retries--;
			await sleep(process.env.NODE_ENV == "development" ? 2_500 : 1_500);
			console.log(retries, "Retrying", url);
			continue;
		}
		break;
	} while (retries > 0);
	return rs;
}
